// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    scroll-behavior: smooth;
}

body {
    margin: 0;
    padding: 0;
    font-family: 'Nunito Sans', Sans-serif, serif;
    background-color: #ffffff;
}

body::-webkit-scrollbar {
    width: 4px;
}

body::-webkit-scrollbar-thumb {
    background: #e0e0e0;
}

body::-webkit-scrollbar-track {
    background: #eeeeee;
}

.home-container {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    display: inline-block;
}

.home-top-bar {
    width: 100%;
    height: 10%;
    display: flex;
    align-items: center;
}

.home-center-bar-container {
    width: 100%;
    height: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.home-center-container_right {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.home-center-container-left {
    width: 50%;
    height: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center
}

.home-top-bar_half {
    height: 100%;
    width: 50%;
    display: flex;
    align-items: center;
}

.home-center-container-left h1 {
    color: #616161;
    font-size: 45px;
    font-weight: 100;
    text-align: center;
    line-height: 72px;
    margin: 10px;
    letter-spacing: -0.01em;
}

.home-center-container-left p {
    color: #445c7b;
    font-size: 30px;
    font-weight: 500;
    line-height: 36px;
    text-align: center;
}

#home-top-bar-privacy-button {
    margin-right: 50px;
    background-color: #1976d2;
    padding: 10px 20px 10px 20px;
    border-radius: 25px;
    color: #ffffff;
    font-size: 17px;
    cursor: pointer;
}

#home-top-bar-privacy-button:hover {
    background-color: #e0e0e0;
    color: #004ba0;
}

.title h1 {
    color: #212121;
    font-size: 35px;
    font-weight: 700;
    line-height: 50px;
    margin: 10px 0 50px 0;
    text-align: center;
}

.row {
    width: 80%
}

.page-container {
    width: 100%;
    height: 100%;
    padding: 0;
}

#home-first-section {
    width: 100%;
    height: 100vh;
    background-repeat: no-repeat;
    object-fit: cover;
    background-size: 100%;
    display: flex;
}

.foreground-layer {
    width: 100%;
    height: 100vh;
    background: #000000bb;
    align-items: center;
    margin: 0;
}

.top-navigator-bar {
    height: 100px;
    width: 100%;
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    margin-top: 20px;
}

.title-banner {
    width: 15%;
    color: #f9f9f9;
    display: inline-flex;
    align-items: center;
    margin-left: 5%;
}

#app-logo {
    width: 250px;
    height: auto;
}

#app-title {
    font-size: 18px;
    margin-left: 10px;
}

.navigators {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 5%;
}


.navigators span {
    width: auto;
    padding: 0 15px 0 15px;
    color: #fff;
    font-size: 18px;
    border-color: transparent;
}

.navigators span:hover {
    color: #f9f9f9;
    cursor: pointer;
    border-color: transparent;
}

#text-mobile-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

#primary-text-box {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 120px;
}

#primary-title {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #f9f9f9;
    text-align: center;
    font-size: 60px;
    margin: 15px 15px 10%;
}

#primary-title p {
    margin: 15px;
    font-weight: bold;
}

#primary-discription {
    color: rgba(255, 255, 255, .5);
    text-align: left;
}

.view-form:hover {
    cursor: pointer;
    border: #1976d2 1px solid;
    color: #1976d2;
    background-color: #f9f9f9;
}

.animation-text {
    margin: 20px;
    font-size: 45px;
}

.animation-text span::before {
    content: "Share Emotions by Connecting Hearts";
    animation: animate infinite 10s;
}

@keyframes animate {

    0% {
        content: "Share Emotions by Connecting Hearts";
    }

    25% {
        content: "Transform Feelings into Connections with SurveyHeart";
    }

    50% {
        content: "Create forms effortlessly with SurveyHeart";
    }

    75% {
        content: "Level up your knowledge with Paperfree Quizzes";
    }
}

.YouTube {
    margin: auto;
    display: flex;
    font-size: 18px;
    cursor: pointer;
    width: fit-content;
    justify-content: center;
    text-decoration: underline;
}

.second-section {
    text-align: center;
}

.home-container h1 {
    font-size: 60px;
}

.home-container h2 {
    font-size: 40px;
}

.nonScroll-navbar {
    display: none;
}

.onScroll-navbar {
    width: 100%;
    display: flex;
    position: fixed;
    top: -90px;
    z-index: 3;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease-in-out;
    font-size: 26px;
    background-color: #FFFFFF;
}

.sticky {
    transform: translateY(70px);
}

#scroll-container {
    width: 100%;
    overflow: hidden;
}

#wrapper {
    display: flex;
}

#images {
    display: flex;
    animation: my-animation 20s linear infinite;
}

#images .image {
    margin: auto;
    padding: 50px;
    object-fit: cover;
}

@keyframes my-animation {
    0% {
        transform: translateX(0%);
    }

    100% {
        transform: translateX(-100%);
    }
}

.third-section, .forth-section, .fifth-section, .sixth-section, .seventh-section {
    margin-top: 150px;
    text-align: center;
}

.fifth-section {
    margin: 150px 60px 60px;
}

.fifth-section .premium-plans {
    display: flex;
    justify-content: center;
}

.fifth-section .premium-plans .border {
    margin: auto;
    height: 250px;
    border: 1px solid #BDBDBD;
}

.fifth-section .premium-plan {
    width: 20%;
    margin: 20px;
    height: 300px;
    color: #FFFFFF;
    border-radius: 20px;
    background-color: #1976D2;
}

.fifth-section .premium-plan h3 {
    font-size: 30px;
}

.sixth-section .templates {
    display: flex;
    justify-content: center;
}

.sixth-section .template {
    width: 15%;
    margin: 20px;
    display: flex;
    height: 230px;
    color: #FFFFFF;
    align-items: center;
    border-radius: 20px;
    background-size: cover;
    justify-content: center;
}

.sixth-section .template h3 {
    text-shadow: 1px 1px black;
}

.demo-popup {
    width: 70%;
    height: 75%;
    border-radius: 10px;
    background: #FFFFFF;
}

.request-sent {
    margin-top: 13%;
    text-align: center;
}

.request-sent .green-tick {
    width: 60px;
    height: 60px;
    margin: auto;
    display: flex;
    align-items: center;
    border-radius: 50px;
    background-color: green;
    justify-content: center;
}

.request-sent .green-tick img {
    width: 50px;
}

.demo {
    display: flex;
    margin: 0 50px 50px;
    justify-content: space-between;
}

.demo .phone-number {
    display: flex;
    align-items: baseline;
}

.country-code {
    width: 30%;
    height: 60%;
    border-radius: 10px;
    background-color: #FFFFFF;
}

.pop-up-header {
    padding: 2px 19px;
    font-size: 16px;
    display: flex;
    background-color: #1976D2;
    color: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 50px;
    align-items: center;
    justify-content: space-between;
}

.pop-up-header span {
    font-size: 18px;
}

.search {
    display: flex;
    justify-content: center;
}

.search .full-width {
    width: 90%;
}

.codes {
    overflow-y: scroll;
    height: 75%;
}

.code-row {
    width: 90%;
    margin: auto;
    cursor: pointer;
}

.code-row p {
    font-size: 18px;
    padding-bottom: 10px;
    border-bottom: 1px solid #BDBDBD;
}

.code-row p span {
    margin: 0 10px;
}

/*
#download {
    height: 10%;
    display: inline-flex;
    border-radius: 50px;
    background-color: #1976d2;
    color: #f9f9f9;
    margin-top: 10px;
    font-size: 20px;
    padding-left: 6%;
    padding-right: 6%;
    align-items: center;
}*/

#download-image {
    width: 250px;
    height: auto;
}

#download-image:hover {
    color: #212121;
    cursor: pointer;
}

/*#download-text {
    margin: 5% 5% 5% 0;
}*/

#mobile-screen {
    width: 50%;
    display: inline-block;
    justify-content: center;
}

#mobile-image {
    display: block;
    width: 35%;
    height: auto;
    margin: 10% 32.5% 0 32.5%;
}

#home-second-section {
    width: 100%;
    height: auto;
    padding-bottom: 2.5%;
    padding-top: 2.5%;
    background-color: #fafafa;
}

#second-section-title-bar {
    width: 100%;
    display: flex;
    height: auto;
    padding-bottom: 25px;
    justify-content: center;
}

#second-section-title-text {
    display: inline-block;
    align-items: center;
}

#page-title {
    font-weight: 300;
    color: #212121;
}

#sample-survey-underline {
    width: 25px;
    height: 2px;
    background-color: #424242;
    margin: 6px 85px 6px 85px;
    transition: margin-top 1s;
}

.form-cards-layer {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

#form-cards-container {
    width: 80%;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
}

.form-card {
    width: 280px;
    height: auto;
    margin: 20px 20px 35px 20px;
    display: block;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: #9e9e9e 0 0 10px 0;
}

.form-card:hover {
    cursor: pointer;
    box-shadow: #757575 0 0 40px 0;
}

.form-contents {
    margin: 0 15px 0 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.form-card img {
    width: 100%;
    height: auto;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.form-contents h2 {
    color: #212121;
    max-height: 70px;
    height: auto;
    font-weight: normal;
    margin: 20px 0 20px 0;
    overflow: hidden;
    text-align: center;
}

.form-contents p {
    line-height: 25px;
    color: #616161;
    margin-top: 0;
    overflow: hidden;
    text-align: center;
}

.form-contents button {
    padding: 10px 15px 10px 15px;
    font-size: 14px;
    border-radius: 50px;
    background-color: #1976d2;
    color: #f9f9f9;
    margin-bottom: 20px;
}

.home-features-section {
    width: 100%;
    display: flex;
}

#home-third-left-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30%;
    padding-bottom: 30px;
}

#home-third-right-container {
    width: 65%;
    justify-content: center;
    display: flex;
    padding-bottom: 30px;
}

#home-fourth-left-container {
    width: 65%;
    justify-content: center;
    display: flex;
    padding-bottom: 30px;

}

#home-fourth-right-container {
    width: 30%;
    height: auto;
    padding: 0 0 30px 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

#mobile-screenshot-1 {
    width: 100%;
    height: auto;
    margin: 10px;
    display: flex;
    align-items: center;
}

#mobile-screenshot-1 img {
    width: 100%;
    height: auto;
    justify-content: right;
}

#mobile-screenshot-2 {
    width: 100%;
    height: auto;
    margin: 20px 0 20px 0;
    display: flex;
    align-items: center;
}

#mobile-screenshot-2 img {
    width: 90%;
    height: auto;
    justify-content: center;
}

.features-container {
    width: 60%;
    height: auto;
    margin-top: 10px;
    display: block;
}

.feature-title-bar {
    display: block;
    padding-top: 50px;
    width: 100%;
    text-align: center;
}

.feature-title-bar h3 {
    color: #212121;
    font-weight: 300;
    font-size: 45px;
    width: 100%;
    text-align: center;
    margin: 0 0 0 0;
}

.features-underline {
    width: 25px;
    height: 2px;
    background-color: #424242;
}

.feature-icon {
    width: 80px;
    height: 80px;
    border-radius: 100px;
    background-color: #004ba0;
    box-shadow: #004ba0bb 0 2px 10px 0;
}

.feature-container {
    display: flex;
    margin-top: 40px;
}

.feature-icon img {
    width: 40px;
    height: auto;
    margin: 20px 20px 20px 20px;
}

.feature-text-container {
    margin-left: 40px;
    display: block;
    width: 100%;
}

.feature-text-container p {
    font-size: 20px;
    text-align: justify;
}

.feature-text-container h2 {
    margin-top: 10px;
    margin-bottom: 10px;
    color: #212121;
    font-weight: normal;
}

#about-us-page {
    width: 100%;
    display: block;
    justify-content: center;
    padding-bottom: 25px;
    background-color: #fafafa;
}

#full-card {
    width: 100%;
    padding: 5px 0;
    height: auto;
    text-align: center;
}

/*h1 {
    margin-top: 0;
    padding-top: 30px;
    font-size: 36px;
    color: #212121;
}*/

#full-card h3 {
    font-weight: bold;
    font-size: 45px;
    color: #212121;
}

#statistics {
    width: 100%;
    display: flex;
    justify-content: center;
}

#statistics div {
    margin: 0 12% 2% 12%;
}

.no-of-users {
    width: 240px;
}

.no-of-users label {
    font-size: 22px;
}

.count {
    color: #212121;
    font-weight: bold;
    font-size: 20px;
}

#statistics p {
    color: #004ba0;
    font-weight: bold;
    font-size: 30px;
    margin: 10px 10px;
}

#second-section-title-text h3 {
    font-size: 45px;
    color: #212121;
    padding: 20px 20px 0 30px;
    font-weight: normal;
    margin-bottom: 5px;
    margin-top: 0;
}

.user-country h3 {
    margin: 20px 0 0 0;

}

.user-country h2 {
    color: #004ba0;
    font-size: 30px;
}

#country-list {
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
}

#country-list p {
    width: 150px;
    color: #212121;
    font-size: 22px;
}

.column-1 {
    margin-right: 5%;
}

.column-2 {
    margin: 0 5%;
}

.column-3 {
    margin-left: 5%;
}

.content-about-us {
    width: 100%;
    height: auto;
    padding-bottom: 20px;
}

.strikeout {
    position: relative;
}

.strikeout::after {
    border-bottom: 0.025em solid #9e9e9e;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 55%;
}

.content-about-us p {
    width: 70%;
    margin: 2% 15%;
    font-size: 22px;
    line-height: 36px;
    color: #212121;
    text-shadow: 2px 4px #ffffff;
}

.about-us-stats-container {
    display: flex;
}

.mobile-navigation-menu {
    display: none;
}

.title-banner i {
    display: none;
}

.dev-info-page {
    width: 100%;
    height: 60%;
    display: flex;
    align-items: center;
    background-color: #fafafa;
    flex-direction: column;
}

.profile-container {
    width: 60%;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.individual-profile {
    display: flex;
    border-radius: 50%;
    margin: 10px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.image-holder {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    object-fit: cover;
}

.Get-started-button-label {
    font-size: 20px;
    margin-right: 20px;
    padding: 0
}

.google-play-badge-mobile {
    display: none;
}

.mobile-container {
    display: none;
}

.footer-distributed {
    display: flex;
    background: #F5F5F5;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
    width: 100%;
    text-align: left;
    font: bold 16px sans-serif;
    padding: 55px 50px;
}

.footer-distributed .footer-left {
    width: 35%;
    display: flex;
    flex-direction: column;
    vertical-align: top;
}

.footer-distributed .footer-center,
.footer-distributed .footer-right {
    display: inline-block;
    vertical-align: top;
}

/* Footer left */

.footer-left {
    display: flex;
    flex-direction: column;
}

.footer-left .quick-links span {
    display: block;
    font-weight: normal;
    font-size: 20px;
    line-height: 2;
    cursor: pointer;
    width: fit-content;
}

.footer-left .footer-quick-links {
    display: block;
    color: #1976D2;
    font-size: 30px;
    font-weight: bold;
}

.footer-center .address {
    display: block;
    color: #1976D2;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 20px
}

/*
.footer-distributed .footer-left {
    width: 40%;
}
*/

/* The company logo */

.footer-distributed h3 {
    color: #000000;
    font: normal 36px 'Open Sans', cursive;
    margin: 0;
}

.footer-distributed h3 span {
    color: lightseagreen;
}

/* Footer links */

.footer-distributed .footer-links {
    color: #000000;
    margin: 20px 0 12px;
    padding: 0;
}

.footer-distributed .footer-links a {
    display: inline-block;
    line-height: 1.8;
    font-weight: 400;
    text-decoration: none;
    color: inherit;
}

.footer-distributed .footer-company-name {
    color: #222;
    font-size: 14px;
    font-weight: normal;
    margin: 0;
}

/* Footer Center */

.footer-distributed .footer-center {
    width: 40%;
}

.footer-distributed .footer-center i {
    background-color: #33383b;
    color: #ffffff;
    font-size: 25px;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    text-align: center;
    line-height: 42px;
    margin: 10px 15px;
    vertical-align: middle;
}

.footer-distributed .footer-center i.fa-envelope {
    font-size: 17px;
    line-height: 38px;
}

.footer-distributed .footer-center p {
    display: inline-block;
    color: #000000;
    font-weight: 400;
    vertical-align: middle;
    margin: 0;
}

.footer-distributed .footer-center p span {
    display: block;
    font-weight: normal;
    font-size: 20px;
    line-height: 2;
}

.footer-distributed .footer-center p a {
    color: #42a5f5;
    text-decoration: none;;
}

.footer-distributed .footer-links a:before {
    content: "|";
    font-weight: 300;
    font-size: 20px;
    left: 0;
    color: #000000;
    display: inline-block;
    padding-right: 5px;
}

.footer-distributed .footer-links .link-1:before {
    content: none;
}

/* Footer Right */

.footer-distributed .footer-right {
    width: 20%;
}

.footer-distributed .footer-company-about {
    line-height: 30px;
    color: #000000;
    font-size: 18px;
    font-weight: normal;
    margin: 0 0 20px;
}

.footer-distributed .footer-company-about span {
    display: block;
    color: #1976D2;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 20px;
}

.footer-distributed .footer-icons {
    margin-top: 25px;
}

.footer-distributed .footer-icons a {
    display: inline-block;
    width: 35px;
    height: 35px;
    cursor: pointer;
    background-color: #33383b;
    border-radius: 2px;

    font-size: 20px;
    color: #ffffff;
    text-align: center;
    line-height: 35px;

    margin-right: 3px;
    margin-bottom: 5px;
}

.login-container {
    display: flex;
    align-items: center;
}

.sign-in-button {
    border-radius: 5px !important;
    padding: 5px 10px !important;
    border: 1px solid #fff !important;
    margin: 0 15px 0 15px;
}

.Get-started-button {
    background-color: #004ba0 !important;
    border-radius: 5px !important;
    padding: 25px 20px !important;
    border: 1px solid #004ba0;
    margin-top: 30px;
    margin-bottom: 20px;
}

.get-started-button {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 220px;
}

.download-apps {
    display: flex;
}

#ios-download-image {
    width: 13.5rem;
    padding: 15px 0;
}

.sign-up-button {
    background-color: #004ba0 !important;
    border-radius: 5px !important;
    padding: 5px 10px !important;
    border: 1px solid #004ba0;
}

.sign-in-button-mobile {
    background-color: #004ba0 !important;
    border-radius: 2px !important;
    padding: 4px !important;
    height: 28px !important;
    border: 1px solid #004ba0;
    margin: 0 15px 0 15px;
}

.sign-up-button-label, .sign-in-button-label {
    color: #fff !important;
    font-size: 16px;
    text-transform: none !important;
}

@media screen and (max-width: 650px) {

    .home-container h1 {
        font-size: 25px;
    }

    .home-container h2 {
        font-size: 20px;
    }

    .demo-popup {
        width: 90%;
        height: auto;
    }

    .demo {
        display: block;
        margin: 0 20px 20px;
    }

    .request-sent {
        margin-top: 10%;
        margin-bottom: 15%;
        text-align: center;
    }

    .request-sent .green-tick {
        width: 50px;
        height: 50px;
    }

    .request-sent .green-tick img {
        width: 40px;
    }

    .animation-text {
        font-size: 24px;
    }

    .footer-distributed .footer-company-about span, .footer-quick-links p, .address div {
        font-size: 25px;
        margin-top: 50px;
    }

    .download-apps {
        display: block;
    }

    #ios-download-image {
        width: 12rem;
        padding: 0;
    }

    .title-banner i {
        display: block;
        font-size: 35px;
        margin: 0;
    }

    .mobile-container {
        display: flex;
        align-items: center;
    }

    .mobile-navigation-menu {
        display: none;
        height: 100vh;
        width: 100vw;
        background-color: rgba(0, 0, 0, 0.90);
        position: fixed;
        z-index: 12;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .mobile-navigation-menu span, .mobile-navigation-menu button {
        color: #9e9e9e;
        font-size: 24px;
        margin: 12px 0;
    }

    .mobile-navigation-menu i {
        margin-top: 20px;
        color: #ffffff;
        font-size: 40px;
    }

    .top-navigator-bar {
        height: auto;
        align-items: flex-start;
    }

    #app-logo {
        width: 180px;
    }

    .navigators {
        display: none;
    }

    .second-section, .third-section, .forth-section, .fifth-section, .sixth-section, .seventh-section {
        margin-top: 50px;
    }

    #images .image {
        padding: 20px;
    }

    #images .image img {
        width: 100px;
        height: 50px;
    }

    .forth-section h3 {
        padding: 0;
    }

    .fifth-section {
        margin: 100px 40px 40px 40px;
    }

    .fifth-section .premium-plans {
        display: block;
    }

    .fifth-section .premium-plan {
        margin: 0;
        width: auto;
        height: 180px;
        border-radius: 10px;
    }

    .fifth-section .premium-plan h3 {
        font-size: 25px;
    }

    .fifth-section .premium-plans .border {
        display: none;
    }

    .sixth-section .templates {
        display: block;
    }

    .sixth-section .template {
        width: auto;
    }

    .title-banner {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 2%;
    }

    #primary-text-box {
        width: 100%;
    }

    #primary-title {
        text-align: center;
        font-size: 30px;
        padding-bottom: 10%;
    }

    #primary-title p {
        line-height: 40px;
    }

    #primary-discription {
        text-align: center;
        margin: 15px 20px 15px 20px;
    }

    .google-play-badge-mobile {
        display: block;
    }

    #download-image {
        width: 220px;
    }

    #download {
        margin-right: 27.5%;
        margin-left: 27.5%;
    }

    #mobile-screen {
        width: 100%;
    }

    #mobile-image {
        width: 60%;
        height: auto;
        margin: 15% 20% 0 20%;
    }

    #home-second-section {
        width: 100%;
        height: auto;
        padding-bottom: 5%;
    }

    #second-section-title-bar {
        width: 100%;
        display: flex;
        height: auto;
        padding: 0;
        justify-content: center;
    }

    #second-section-title-text {
        display: inline-block;
        padding: 10px;
        align-content: center;

    }

    #page-title {
        font-size: 32px;
        color: #424242;
    }

    #sample-survey-underline {
        width: 25px;
        height: 2px;
        background-color: #424242;
        /*        margin: 6px 55px 6px 55px;*/
        transition: 0.4s;
    }

    .form-cards-layer {
        width: 90%;
        margin: 5% 5% 5% 5%;
        display: block;
    }

    #form-cards-container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .home-features-section {
        display: block;
        height: auto;
    }

    #home-third-left-container {
        width: 100%;
        height: auto;
    }

    #home-third-right-container {
        width: 100%;
        height: auto;
    }

    #home-fourth-left-container {
        width: 100%;
        height: auto;
    }

    #home-fourth-right-container {
        width: 100%;
        height: auto;

    }

    #mobile-screenshot-1 {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    #mobile-screenshot-2 {
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 10px;
    }

    .features-container {
        width: 90%;
        margin-top: 50px;
    }

    .feature-title-bar {
        display: block;
        padding-bottom: 25px;
        padding-top: 25px;
    }

    .feature-title-bar h3 {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .features-underline {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 48% 0 48%;
    }

    .feature-icon {
        width: 50px;
        height: 50px;
    }

    .feature-icon img {
        width: 25px;
        height: auto;
        margin: 12.5px 12.5px 12.5px 12.5px;
    }

    .feature-text-container {
        margin-left: 20px;
    }

    .feature-container {
        margin-top: 20px;
    }

    #full-card {
        width: 100%;
    }

    #country-list {
        width: 100%;
    }

    #country-list p {
        width: 70px;
        font-size: 20px;
    }

    #statistics div {
        margin: 2% 6% 2% 6%;
    }

    h3 {
        padding-top: 20px;
    }

    .content-about-us {
        height: auto;
    }

    .content-about-us p {
        width: 90%;
        margin: 3% 5% 0 5%;
        padding-bottom: 5%;
        height: auto;
        font-size: 16px;
        line-height: 30px;
    }

    .profile-container {
        width: 100%;
        flex-flow: column;
        justify-content: center;
    }

    .footer-distributed {
        display: block;
    }

    .footer-left .quick-links span {
        width: auto;
    }
}

/* If you don't want the footer to be responsive, remove these media queries */

@media (max-width: 880px) {
    .footer-distributed {
        font: bold 14px sans-serif;
    }

    .footer-distributed .footer-left,
    .footer-distributed .footer-left .quick-links,
    .footer-distributed .footer-center,
    .footer-distributed .footer-right {
        display: block;
        width: 100%;
        margin-bottom: 10px;
        text-align: center;
    }

    .footer-distributed .footer-center i {
        margin-left: 0;
    }
}

@media screen and (max-width: 1150px) {
    .top-navigator-bar {
        flex-wrap: wrap;
    }

    .navigators {
        justify-content: flex-start;
        margin-left: 5%;
    }

    #home-first-section {
        background-size: auto 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/home/css/home-page.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,8CAA8C;IAC9C,+BAA+B;AACnC;;AAEA;;IAEI;QACI,8CAA8C;IAClD;;IAEA;QACI,+DAA+D;IACnE;;IAEA;QACI,qDAAqD;IACzD;;IAEA;QACI,yDAAyD;IAC7D;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;;;;;;;;EAYE;;AAEF;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;;EAEE;;AAEF;IACI,UAAU;IACV,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,oBAAoB;;AAExB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;;;EAKE;;AAEF;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,gBAAgB;;AAEhB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;;;;CAIC;;AAED,qBAAqB;;AAErB;IACI,cAAc;IACd,sCAAsC;IACtC,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA,iBAAiB;;AAEjB;IACI,cAAc;IACd,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA,kBAAkB;;AAElB;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,OAAO;IACP,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,iBAAiB;;AAEjB;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;;IAElB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;;IAEjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,+BAA+B;AACnC;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;QACf,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,aAAa;QACb,YAAY;QACZ,qCAAqC;QACrC,eAAe;QACf,WAAW;QACX,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,2BAA2B;IAC/B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,YAAY;QACZ,UAAU;QACV,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;QACrB,aAAa;QACb,qBAAqB;;IAEzB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,yBAAyB;QACzB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;;IAEhB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mCAAmC;IACvC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,8EAA8E;;AAE9E;IACI;QACI,0BAA0B;IAC9B;;IAEA;;;;QAII,cAAc;QACd,WAAW;QACX,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,2BAA2B;QAC3B,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["html {\n    scroll-behavior: smooth;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: 'Nunito Sans', Sans-serif, serif;\n    background-color: #ffffff;\n}\n\nbody::-webkit-scrollbar {\n    width: 4px;\n}\n\nbody::-webkit-scrollbar-thumb {\n    background: #e0e0e0;\n}\n\nbody::-webkit-scrollbar-track {\n    background: #eeeeee;\n}\n\n.home-container {\n    height: 100%;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n}\n\n.home-top-bar {\n    width: 100%;\n    height: 10%;\n    display: flex;\n    align-items: center;\n}\n\n.home-center-bar-container {\n    width: 100%;\n    height: 90%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.home-center-container_right {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.home-center-container-left {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    flex-flow: column;\n    align-items: center;\n    justify-content: center\n}\n\n.home-top-bar_half {\n    height: 100%;\n    width: 50%;\n    display: flex;\n    align-items: center;\n}\n\n.home-center-container-left h1 {\n    color: #616161;\n    font-size: 45px;\n    font-weight: 100;\n    text-align: center;\n    line-height: 72px;\n    margin: 10px;\n    letter-spacing: -0.01em;\n}\n\n.home-center-container-left p {\n    color: #445c7b;\n    font-size: 30px;\n    font-weight: 500;\n    line-height: 36px;\n    text-align: center;\n}\n\n#home-top-bar-privacy-button {\n    margin-right: 50px;\n    background-color: #1976d2;\n    padding: 10px 20px 10px 20px;\n    border-radius: 25px;\n    color: #ffffff;\n    font-size: 17px;\n    cursor: pointer;\n}\n\n#home-top-bar-privacy-button:hover {\n    background-color: #e0e0e0;\n    color: #004ba0;\n}\n\n.title h1 {\n    color: #212121;\n    font-size: 35px;\n    font-weight: 700;\n    line-height: 50px;\n    margin: 10px 0 50px 0;\n    text-align: center;\n}\n\n.row {\n    width: 80%\n}\n\n.page-container {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n}\n\n#home-first-section {\n    width: 100%;\n    height: 100vh;\n    background-repeat: no-repeat;\n    object-fit: cover;\n    background-size: 100%;\n    display: flex;\n}\n\n.foreground-layer {\n    width: 100%;\n    height: 100vh;\n    background: #000000bb;\n    align-items: center;\n    margin: 0;\n}\n\n.top-navigator-bar {\n    height: 100px;\n    width: 100%;\n    align-items: center;\n    display: flex;\n    flex-wrap: nowrap;\n    margin-top: 20px;\n}\n\n.title-banner {\n    width: 15%;\n    color: #f9f9f9;\n    display: inline-flex;\n    align-items: center;\n    margin-left: 5%;\n}\n\n#app-logo {\n    width: 250px;\n    height: auto;\n}\n\n#app-title {\n    font-size: 18px;\n    margin-left: 10px;\n}\n\n.navigators {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-right: 5%;\n}\n\n\n.navigators span {\n    width: auto;\n    padding: 0 15px 0 15px;\n    color: #fff;\n    font-size: 18px;\n    border-color: transparent;\n}\n\n.navigators span:hover {\n    color: #f9f9f9;\n    cursor: pointer;\n    border-color: transparent;\n}\n\n#text-mobile-box {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#primary-text-box {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 120px;\n}\n\n#primary-title {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    color: #f9f9f9;\n    text-align: center;\n    font-size: 60px;\n    margin: 15px 15px 10%;\n}\n\n#primary-title p {\n    margin: 15px;\n    font-weight: bold;\n}\n\n#primary-discription {\n    color: rgba(255, 255, 255, .5);\n    text-align: left;\n}\n\n.view-form:hover {\n    cursor: pointer;\n    border: #1976d2 1px solid;\n    color: #1976d2;\n    background-color: #f9f9f9;\n}\n\n.animation-text {\n    margin: 20px;\n    font-size: 45px;\n}\n\n.animation-text span::before {\n    content: \"Share Emotions by Connecting Hearts\";\n    animation: animate infinite 10s;\n}\n\n@keyframes animate {\n\n    0% {\n        content: \"Share Emotions by Connecting Hearts\";\n    }\n\n    25% {\n        content: \"Transform Feelings into Connections with SurveyHeart\";\n    }\n\n    50% {\n        content: \"Create forms effortlessly with SurveyHeart\";\n    }\n\n    75% {\n        content: \"Level up your knowledge with Paperfree Quizzes\";\n    }\n}\n\n.YouTube {\n    margin: auto;\n    display: flex;\n    font-size: 18px;\n    cursor: pointer;\n    width: fit-content;\n    justify-content: center;\n    text-decoration: underline;\n}\n\n.second-section {\n    text-align: center;\n}\n\n.home-container h1 {\n    font-size: 60px;\n}\n\n.home-container h2 {\n    font-size: 40px;\n}\n\n.nonScroll-navbar {\n    display: none;\n}\n\n.onScroll-navbar {\n    width: 100%;\n    display: flex;\n    position: fixed;\n    top: -90px;\n    z-index: 3;\n    align-items: center;\n    justify-content: center;\n    transition: 0.2s ease-in-out;\n    font-size: 26px;\n    background-color: #FFFFFF;\n}\n\n.sticky {\n    transform: translateY(70px);\n}\n\n#scroll-container {\n    width: 100%;\n    overflow: hidden;\n}\n\n#wrapper {\n    display: flex;\n}\n\n#images {\n    display: flex;\n    animation: my-animation 20s linear infinite;\n}\n\n#images .image {\n    margin: auto;\n    padding: 50px;\n    object-fit: cover;\n}\n\n@keyframes my-animation {\n    0% {\n        transform: translateX(0%);\n    }\n\n    100% {\n        transform: translateX(-100%);\n    }\n}\n\n.third-section, .forth-section, .fifth-section, .sixth-section, .seventh-section {\n    margin-top: 150px;\n    text-align: center;\n}\n\n.fifth-section {\n    margin: 150px 60px 60px;\n}\n\n.fifth-section .premium-plans {\n    display: flex;\n    justify-content: center;\n}\n\n.fifth-section .premium-plans .border {\n    margin: auto;\n    height: 250px;\n    border: 1px solid #BDBDBD;\n}\n\n.fifth-section .premium-plan {\n    width: 20%;\n    margin: 20px;\n    height: 300px;\n    color: #FFFFFF;\n    border-radius: 20px;\n    background-color: #1976D2;\n}\n\n.fifth-section .premium-plan h3 {\n    font-size: 30px;\n}\n\n.sixth-section .templates {\n    display: flex;\n    justify-content: center;\n}\n\n.sixth-section .template {\n    width: 15%;\n    margin: 20px;\n    display: flex;\n    height: 230px;\n    color: #FFFFFF;\n    align-items: center;\n    border-radius: 20px;\n    background-size: cover;\n    justify-content: center;\n}\n\n.sixth-section .template h3 {\n    text-shadow: 1px 1px black;\n}\n\n.demo-popup {\n    width: 70%;\n    height: 75%;\n    border-radius: 10px;\n    background: #FFFFFF;\n}\n\n.request-sent {\n    margin-top: 13%;\n    text-align: center;\n}\n\n.request-sent .green-tick {\n    width: 60px;\n    height: 60px;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    border-radius: 50px;\n    background-color: green;\n    justify-content: center;\n}\n\n.request-sent .green-tick img {\n    width: 50px;\n}\n\n.demo {\n    display: flex;\n    margin: 0 50px 50px;\n    justify-content: space-between;\n}\n\n.demo .phone-number {\n    display: flex;\n    align-items: baseline;\n}\n\n.country-code {\n    width: 30%;\n    height: 60%;\n    border-radius: 10px;\n    background-color: #FFFFFF;\n}\n\n.pop-up-header {\n    padding: 2px 19px;\n    font-size: 16px;\n    display: flex;\n    background-color: #1976D2;\n    color: white;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    height: 50px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.pop-up-header span {\n    font-size: 18px;\n}\n\n.search {\n    display: flex;\n    justify-content: center;\n}\n\n.search .full-width {\n    width: 90%;\n}\n\n.codes {\n    overflow-y: scroll;\n    height: 75%;\n}\n\n.code-row {\n    width: 90%;\n    margin: auto;\n    cursor: pointer;\n}\n\n.code-row p {\n    font-size: 18px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #BDBDBD;\n}\n\n.code-row p span {\n    margin: 0 10px;\n}\n\n/*\n#download {\n    height: 10%;\n    display: inline-flex;\n    border-radius: 50px;\n    background-color: #1976d2;\n    color: #f9f9f9;\n    margin-top: 10px;\n    font-size: 20px;\n    padding-left: 6%;\n    padding-right: 6%;\n    align-items: center;\n}*/\n\n#download-image {\n    width: 250px;\n    height: auto;\n}\n\n#download-image:hover {\n    color: #212121;\n    cursor: pointer;\n}\n\n/*#download-text {\n    margin: 5% 5% 5% 0;\n}*/\n\n#mobile-screen {\n    width: 50%;\n    display: inline-block;\n    justify-content: center;\n}\n\n#mobile-image {\n    display: block;\n    width: 35%;\n    height: auto;\n    margin: 10% 32.5% 0 32.5%;\n}\n\n#home-second-section {\n    width: 100%;\n    height: auto;\n    padding-bottom: 2.5%;\n    padding-top: 2.5%;\n    background-color: #fafafa;\n}\n\n#second-section-title-bar {\n    width: 100%;\n    display: flex;\n    height: auto;\n    padding-bottom: 25px;\n    justify-content: center;\n}\n\n#second-section-title-text {\n    display: inline-block;\n    align-items: center;\n}\n\n#page-title {\n    font-weight: 300;\n    color: #212121;\n}\n\n#sample-survey-underline {\n    width: 25px;\n    height: 2px;\n    background-color: #424242;\n    margin: 6px 85px 6px 85px;\n    transition: margin-top 1s;\n}\n\n.form-cards-layer {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n#form-cards-container {\n    width: 80%;\n    justify-content: center;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.form-card {\n    width: 280px;\n    height: auto;\n    margin: 20px 20px 35px 20px;\n    display: block;\n    background-color: #ffffff;\n    border-radius: 10px;\n    box-shadow: #9e9e9e 0 0 10px 0;\n}\n\n.form-card:hover {\n    cursor: pointer;\n    box-shadow: #757575 0 0 40px 0;\n}\n\n.form-contents {\n    margin: 0 15px 0 15px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.form-card img {\n    width: 100%;\n    height: auto;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\n.form-contents h2 {\n    color: #212121;\n    max-height: 70px;\n    height: auto;\n    font-weight: normal;\n    margin: 20px 0 20px 0;\n    overflow: hidden;\n    text-align: center;\n}\n\n.form-contents p {\n    line-height: 25px;\n    color: #616161;\n    margin-top: 0;\n    overflow: hidden;\n    text-align: center;\n}\n\n.form-contents button {\n    padding: 10px 15px 10px 15px;\n    font-size: 14px;\n    border-radius: 50px;\n    background-color: #1976d2;\n    color: #f9f9f9;\n    margin-bottom: 20px;\n}\n\n.home-features-section {\n    width: 100%;\n    display: flex;\n}\n\n#home-third-left-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30%;\n    padding-bottom: 30px;\n}\n\n#home-third-right-container {\n    width: 65%;\n    justify-content: center;\n    display: flex;\n    padding-bottom: 30px;\n}\n\n#home-fourth-left-container {\n    width: 65%;\n    justify-content: center;\n    display: flex;\n    padding-bottom: 30px;\n\n}\n\n#home-fourth-right-container {\n    width: 30%;\n    height: auto;\n    padding: 0 0 30px 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n#mobile-screenshot-1 {\n    width: 100%;\n    height: auto;\n    margin: 10px;\n    display: flex;\n    align-items: center;\n}\n\n#mobile-screenshot-1 img {\n    width: 100%;\n    height: auto;\n    justify-content: right;\n}\n\n#mobile-screenshot-2 {\n    width: 100%;\n    height: auto;\n    margin: 20px 0 20px 0;\n    display: flex;\n    align-items: center;\n}\n\n#mobile-screenshot-2 img {\n    width: 90%;\n    height: auto;\n    justify-content: center;\n}\n\n.features-container {\n    width: 60%;\n    height: auto;\n    margin-top: 10px;\n    display: block;\n}\n\n.feature-title-bar {\n    display: block;\n    padding-top: 50px;\n    width: 100%;\n    text-align: center;\n}\n\n.feature-title-bar h3 {\n    color: #212121;\n    font-weight: 300;\n    font-size: 45px;\n    width: 100%;\n    text-align: center;\n    margin: 0 0 0 0;\n}\n\n.features-underline {\n    width: 25px;\n    height: 2px;\n    background-color: #424242;\n}\n\n.feature-icon {\n    width: 80px;\n    height: 80px;\n    border-radius: 100px;\n    background-color: #004ba0;\n    box-shadow: #004ba0bb 0 2px 10px 0;\n}\n\n.feature-container {\n    display: flex;\n    margin-top: 40px;\n}\n\n.feature-icon img {\n    width: 40px;\n    height: auto;\n    margin: 20px 20px 20px 20px;\n}\n\n.feature-text-container {\n    margin-left: 40px;\n    display: block;\n    width: 100%;\n}\n\n.feature-text-container p {\n    font-size: 20px;\n    text-align: justify;\n}\n\n.feature-text-container h2 {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    color: #212121;\n    font-weight: normal;\n}\n\n#about-us-page {\n    width: 100%;\n    display: block;\n    justify-content: center;\n    padding-bottom: 25px;\n    background-color: #fafafa;\n}\n\n#full-card {\n    width: 100%;\n    padding: 5px 0;\n    height: auto;\n    text-align: center;\n}\n\n/*h1 {\n    margin-top: 0;\n    padding-top: 30px;\n    font-size: 36px;\n    color: #212121;\n}*/\n\n#full-card h3 {\n    font-weight: bold;\n    font-size: 45px;\n    color: #212121;\n}\n\n#statistics {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n#statistics div {\n    margin: 0 12% 2% 12%;\n}\n\n.no-of-users {\n    width: 240px;\n}\n\n.no-of-users label {\n    font-size: 22px;\n}\n\n.count {\n    color: #212121;\n    font-weight: bold;\n    font-size: 20px;\n}\n\n#statistics p {\n    color: #004ba0;\n    font-weight: bold;\n    font-size: 30px;\n    margin: 10px 10px;\n}\n\n#second-section-title-text h3 {\n    font-size: 45px;\n    color: #212121;\n    padding: 20px 20px 0 30px;\n    font-weight: normal;\n    margin-bottom: 5px;\n    margin-top: 0;\n}\n\n.user-country h3 {\n    margin: 20px 0 0 0;\n\n}\n\n.user-country h2 {\n    color: #004ba0;\n    font-size: 30px;\n}\n\n#country-list {\n    display: flex;\n    justify-content: center;\n    padding-bottom: 10px;\n}\n\n#country-list p {\n    width: 150px;\n    color: #212121;\n    font-size: 22px;\n}\n\n.column-1 {\n    margin-right: 5%;\n}\n\n.column-2 {\n    margin: 0 5%;\n}\n\n.column-3 {\n    margin-left: 5%;\n}\n\n.content-about-us {\n    width: 100%;\n    height: auto;\n    padding-bottom: 20px;\n}\n\n.strikeout {\n    position: relative;\n}\n\n.strikeout::after {\n    border-bottom: 0.025em solid #9e9e9e;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 55%;\n}\n\n.content-about-us p {\n    width: 70%;\n    margin: 2% 15%;\n    font-size: 22px;\n    line-height: 36px;\n    color: #212121;\n    text-shadow: 2px 4px #ffffff;\n}\n\n.about-us-stats-container {\n    display: flex;\n}\n\n.mobile-navigation-menu {\n    display: none;\n}\n\n.title-banner i {\n    display: none;\n}\n\n.dev-info-page {\n    width: 100%;\n    height: 60%;\n    display: flex;\n    align-items: center;\n    background-color: #fafafa;\n    flex-direction: column;\n}\n\n.profile-container {\n    width: 60%;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n}\n\n.individual-profile {\n    display: flex;\n    border-radius: 50%;\n    margin: 10px;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.image-holder {\n    width: 180px;\n    height: 180px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.Get-started-button-label {\n    font-size: 20px;\n    margin-right: 20px;\n    padding: 0\n}\n\n.google-play-badge-mobile {\n    display: none;\n}\n\n.mobile-container {\n    display: none;\n}\n\n.footer-distributed {\n    display: flex;\n    background: #F5F5F5;\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12);\n    box-sizing: border-box;\n    width: 100%;\n    text-align: left;\n    font: bold 16px sans-serif;\n    padding: 55px 50px;\n}\n\n.footer-distributed .footer-left {\n    width: 35%;\n    display: flex;\n    flex-direction: column;\n    vertical-align: top;\n}\n\n.footer-distributed .footer-center,\n.footer-distributed .footer-right {\n    display: inline-block;\n    vertical-align: top;\n}\n\n/* Footer left */\n\n.footer-left {\n    display: flex;\n    flex-direction: column;\n}\n\n.footer-left .quick-links span {\n    display: block;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 2;\n    cursor: pointer;\n    width: fit-content;\n}\n\n.footer-left .footer-quick-links {\n    display: block;\n    color: #1976D2;\n    font-size: 30px;\n    font-weight: bold;\n}\n\n.footer-center .address {\n    display: block;\n    color: #1976D2;\n    font-size: 30px;\n    font-weight: bold;\n    margin-bottom: 20px\n}\n\n/*\n.footer-distributed .footer-left {\n    width: 40%;\n}\n*/\n\n/* The company logo */\n\n.footer-distributed h3 {\n    color: #000000;\n    font: normal 36px 'Open Sans', cursive;\n    margin: 0;\n}\n\n.footer-distributed h3 span {\n    color: lightseagreen;\n}\n\n/* Footer links */\n\n.footer-distributed .footer-links {\n    color: #000000;\n    margin: 20px 0 12px;\n    padding: 0;\n}\n\n.footer-distributed .footer-links a {\n    display: inline-block;\n    line-height: 1.8;\n    font-weight: 400;\n    text-decoration: none;\n    color: inherit;\n}\n\n.footer-distributed .footer-company-name {\n    color: #222;\n    font-size: 14px;\n    font-weight: normal;\n    margin: 0;\n}\n\n/* Footer Center */\n\n.footer-distributed .footer-center {\n    width: 40%;\n}\n\n.footer-distributed .footer-center i {\n    background-color: #33383b;\n    color: #ffffff;\n    font-size: 25px;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    text-align: center;\n    line-height: 42px;\n    margin: 10px 15px;\n    vertical-align: middle;\n}\n\n.footer-distributed .footer-center i.fa-envelope {\n    font-size: 17px;\n    line-height: 38px;\n}\n\n.footer-distributed .footer-center p {\n    display: inline-block;\n    color: #000000;\n    font-weight: 400;\n    vertical-align: middle;\n    margin: 0;\n}\n\n.footer-distributed .footer-center p span {\n    display: block;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 2;\n}\n\n.footer-distributed .footer-center p a {\n    color: #42a5f5;\n    text-decoration: none;;\n}\n\n.footer-distributed .footer-links a:before {\n    content: \"|\";\n    font-weight: 300;\n    font-size: 20px;\n    left: 0;\n    color: #000000;\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.footer-distributed .footer-links .link-1:before {\n    content: none;\n}\n\n/* Footer Right */\n\n.footer-distributed .footer-right {\n    width: 20%;\n}\n\n.footer-distributed .footer-company-about {\n    line-height: 30px;\n    color: #000000;\n    font-size: 18px;\n    font-weight: normal;\n    margin: 0 0 20px;\n}\n\n.footer-distributed .footer-company-about span {\n    display: block;\n    color: #1976D2;\n    font-size: 30px;\n    font-weight: bold;\n    margin-bottom: 20px;\n}\n\n.footer-distributed .footer-icons {\n    margin-top: 25px;\n}\n\n.footer-distributed .footer-icons a {\n    display: inline-block;\n    width: 35px;\n    height: 35px;\n    cursor: pointer;\n    background-color: #33383b;\n    border-radius: 2px;\n\n    font-size: 20px;\n    color: #ffffff;\n    text-align: center;\n    line-height: 35px;\n\n    margin-right: 3px;\n    margin-bottom: 5px;\n}\n\n.login-container {\n    display: flex;\n    align-items: center;\n}\n\n.sign-in-button {\n    border-radius: 5px !important;\n    padding: 5px 10px !important;\n    border: 1px solid #fff !important;\n    margin: 0 15px 0 15px;\n}\n\n.Get-started-button {\n    background-color: #004ba0 !important;\n    border-radius: 5px !important;\n    padding: 25px 20px !important;\n    border: 1px solid #004ba0;\n    margin-top: 30px;\n    margin-bottom: 20px;\n}\n\n.get-started-button {\n    margin-top: 30px;\n    margin-bottom: 20px;\n    width: 220px;\n}\n\n.download-apps {\n    display: flex;\n}\n\n#ios-download-image {\n    width: 13.5rem;\n    padding: 15px 0;\n}\n\n.sign-up-button {\n    background-color: #004ba0 !important;\n    border-radius: 5px !important;\n    padding: 5px 10px !important;\n    border: 1px solid #004ba0;\n}\n\n.sign-in-button-mobile {\n    background-color: #004ba0 !important;\n    border-radius: 2px !important;\n    padding: 4px !important;\n    height: 28px !important;\n    border: 1px solid #004ba0;\n    margin: 0 15px 0 15px;\n}\n\n.sign-up-button-label, .sign-in-button-label {\n    color: #fff !important;\n    font-size: 16px;\n    text-transform: none !important;\n}\n\n@media screen and (max-width: 650px) {\n\n    .home-container h1 {\n        font-size: 25px;\n    }\n\n    .home-container h2 {\n        font-size: 20px;\n    }\n\n    .demo-popup {\n        width: 90%;\n        height: auto;\n    }\n\n    .demo {\n        display: block;\n        margin: 0 20px 20px;\n    }\n\n    .request-sent {\n        margin-top: 10%;\n        margin-bottom: 15%;\n        text-align: center;\n    }\n\n    .request-sent .green-tick {\n        width: 50px;\n        height: 50px;\n    }\n\n    .request-sent .green-tick img {\n        width: 40px;\n    }\n\n    .animation-text {\n        font-size: 24px;\n    }\n\n    .footer-distributed .footer-company-about span, .footer-quick-links p, .address div {\n        font-size: 25px;\n        margin-top: 50px;\n    }\n\n    .download-apps {\n        display: block;\n    }\n\n    #ios-download-image {\n        width: 12rem;\n        padding: 0;\n    }\n\n    .title-banner i {\n        display: block;\n        font-size: 35px;\n        margin: 0;\n    }\n\n    .mobile-container {\n        display: flex;\n        align-items: center;\n    }\n\n    .mobile-navigation-menu {\n        display: none;\n        height: 100vh;\n        width: 100vw;\n        background-color: rgba(0, 0, 0, 0.90);\n        position: fixed;\n        z-index: 12;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .mobile-navigation-menu span, .mobile-navigation-menu button {\n        color: #9e9e9e;\n        font-size: 24px;\n        margin: 12px 0;\n    }\n\n    .mobile-navigation-menu i {\n        margin-top: 20px;\n        color: #ffffff;\n        font-size: 40px;\n    }\n\n    .top-navigator-bar {\n        height: auto;\n        align-items: flex-start;\n    }\n\n    #app-logo {\n        width: 180px;\n    }\n\n    .navigators {\n        display: none;\n    }\n\n    .second-section, .third-section, .forth-section, .fifth-section, .sixth-section, .seventh-section {\n        margin-top: 50px;\n    }\n\n    #images .image {\n        padding: 20px;\n    }\n\n    #images .image img {\n        width: 100px;\n        height: 50px;\n    }\n\n    .forth-section h3 {\n        padding: 0;\n    }\n\n    .fifth-section {\n        margin: 100px 40px 40px 40px;\n    }\n\n    .fifth-section .premium-plans {\n        display: block;\n    }\n\n    .fifth-section .premium-plan {\n        margin: 0;\n        width: auto;\n        height: 180px;\n        border-radius: 10px;\n    }\n\n    .fifth-section .premium-plan h3 {\n        font-size: 25px;\n    }\n\n    .fifth-section .premium-plans .border {\n        display: none;\n    }\n\n    .sixth-section .templates {\n        display: block;\n    }\n\n    .sixth-section .template {\n        width: auto;\n    }\n\n    .title-banner {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-right: 2%;\n    }\n\n    #primary-text-box {\n        width: 100%;\n    }\n\n    #primary-title {\n        text-align: center;\n        font-size: 30px;\n        padding-bottom: 10%;\n    }\n\n    #primary-title p {\n        line-height: 40px;\n    }\n\n    #primary-discription {\n        text-align: center;\n        margin: 15px 20px 15px 20px;\n    }\n\n    .google-play-badge-mobile {\n        display: block;\n    }\n\n    #download-image {\n        width: 220px;\n    }\n\n    #download {\n        margin-right: 27.5%;\n        margin-left: 27.5%;\n    }\n\n    #mobile-screen {\n        width: 100%;\n    }\n\n    #mobile-image {\n        width: 60%;\n        height: auto;\n        margin: 15% 20% 0 20%;\n    }\n\n    #home-second-section {\n        width: 100%;\n        height: auto;\n        padding-bottom: 5%;\n    }\n\n    #second-section-title-bar {\n        width: 100%;\n        display: flex;\n        height: auto;\n        padding: 0;\n        justify-content: center;\n    }\n\n    #second-section-title-text {\n        display: inline-block;\n        padding: 10px;\n        align-content: center;\n\n    }\n\n    #page-title {\n        font-size: 32px;\n        color: #424242;\n    }\n\n    #sample-survey-underline {\n        width: 25px;\n        height: 2px;\n        background-color: #424242;\n        /*        margin: 6px 55px 6px 55px;*/\n        transition: 0.4s;\n    }\n\n    .form-cards-layer {\n        width: 90%;\n        margin: 5% 5% 5% 5%;\n        display: block;\n    }\n\n    #form-cards-container {\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .home-features-section {\n        display: block;\n        height: auto;\n    }\n\n    #home-third-left-container {\n        width: 100%;\n        height: auto;\n    }\n\n    #home-third-right-container {\n        width: 100%;\n        height: auto;\n    }\n\n    #home-fourth-left-container {\n        width: 100%;\n        height: auto;\n    }\n\n    #home-fourth-right-container {\n        width: 100%;\n        height: auto;\n\n    }\n\n    #mobile-screenshot-1 {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n    }\n\n    #mobile-screenshot-2 {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        margin: 10px;\n    }\n\n    .features-container {\n        width: 90%;\n        margin-top: 50px;\n    }\n\n    .feature-title-bar {\n        display: block;\n        padding-bottom: 25px;\n        padding-top: 25px;\n    }\n\n    .feature-title-bar h3 {\n        display: flex;\n        justify-content: center;\n        width: 100%;\n    }\n\n    .features-underline {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0 48% 0 48%;\n    }\n\n    .feature-icon {\n        width: 50px;\n        height: 50px;\n    }\n\n    .feature-icon img {\n        width: 25px;\n        height: auto;\n        margin: 12.5px 12.5px 12.5px 12.5px;\n    }\n\n    .feature-text-container {\n        margin-left: 20px;\n    }\n\n    .feature-container {\n        margin-top: 20px;\n    }\n\n    #full-card {\n        width: 100%;\n    }\n\n    #country-list {\n        width: 100%;\n    }\n\n    #country-list p {\n        width: 70px;\n        font-size: 20px;\n    }\n\n    #statistics div {\n        margin: 2% 6% 2% 6%;\n    }\n\n    h3 {\n        padding-top: 20px;\n    }\n\n    .content-about-us {\n        height: auto;\n    }\n\n    .content-about-us p {\n        width: 90%;\n        margin: 3% 5% 0 5%;\n        padding-bottom: 5%;\n        height: auto;\n        font-size: 16px;\n        line-height: 30px;\n    }\n\n    .profile-container {\n        width: 100%;\n        flex-flow: column;\n        justify-content: center;\n    }\n\n    .footer-distributed {\n        display: block;\n    }\n\n    .footer-left .quick-links span {\n        width: auto;\n    }\n}\n\n/* If you don't want the footer to be responsive, remove these media queries */\n\n@media (max-width: 880px) {\n    .footer-distributed {\n        font: bold 14px sans-serif;\n    }\n\n    .footer-distributed .footer-left,\n    .footer-distributed .footer-left .quick-links,\n    .footer-distributed .footer-center,\n    .footer-distributed .footer-right {\n        display: block;\n        width: 100%;\n        margin-bottom: 10px;\n        text-align: center;\n    }\n\n    .footer-distributed .footer-center i {\n        margin-left: 0;\n    }\n}\n\n@media screen and (max-width: 1150px) {\n    .top-navigator-bar {\n        flex-wrap: wrap;\n    }\n\n    .navigators {\n        justify-content: flex-start;\n        margin-left: 5%;\n    }\n\n    #home-first-section {\n        background-size: auto 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
